import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/")({
	component: DevIndex,
});

function DevIndex() {
	return (
		<div className="mx-auto max-w-3xl px-6 py-12">
			<h1 className="mb-2 text-2xl font-semibold">Dev Tools</h1>
			<p className="text-muted mb-8">
				Internal tools for design and prototyping. Only visible in
				development.
			</p>

			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
				<Link
					to="/dev/style-guide"
					className="border-line bg-card hover:border-subtle rounded-lg border p-6 no-underline transition-colors"
				>
					<h2 className="text-foreground mb-1 text-lg font-medium">
						Style Guide
					</h2>
					<p className="text-muted text-sm">
						Design tokens, typography, colors, and component
						gallery.
					</p>
				</Link>

				<Link
					to="/dev/prototypes"
					className="border-line bg-card hover:border-subtle rounded-lg border p-6 no-underline transition-colors"
				>
					<h2 className="text-foreground mb-1 text-lg font-medium">
						Prototypes
					</h2>
					<p className="text-muted text-sm">
						Page prototypes using real components and Tailwind
						tokens.
					</p>
				</Link>

				<Link
					to="/dev/chat-debug"
					search={{ thread: undefined }}
					className="border-line bg-card hover:border-subtle rounded-lg border p-6 no-underline transition-colors"
				>
					<h2 className="text-foreground mb-1 text-lg font-medium">
						Chat Debug
					</h2>
					<p className="text-muted text-sm">
						Inspect chat threads: system prompt, model, messages,
						and tool calls.
					</p>
				</Link>
			</div>
		</div>
	);
}
